export default __webpack_public_path__ + "static/media/MailSendIcon.729bbb57.PNG";